export default __webpack_public_path__ + "static/media/metamask-accounts-settings-highlight.6814d4c7.png";